import React, { useEffect, useState } from 'react'
import Header from './Header'
import Lenis from '@studio-freight/lenis'
import { ScrollTrigger } from 'gsap/ScrollTrigger'
import gsap from 'gsap'
import { motion, AnimatePresence, LayoutGroup } from 'framer-motion'
import Loader from '../Pages/Loader'


const FileStructure = ({ children }) => {

    const [load, setLoad] = useState(true)

    useEffect(() => {
        const lenis = new Lenis()

        function raf(time) {
            lenis.raf(time)
            requestAnimationFrame(raf)
        }

        requestAnimationFrame(raf)


        lenis.on('scroll', ScrollTrigger.update)

        gsap.ticker.add((time) => {
            lenis.raf(time * 1000)
        })

        gsap.ticker.lagSmoothing(0)

    }, [])

    useEffect(() => {
        load
            ? document.querySelector("body").classList.add("loading")
            : document.querySelector("body").classList.remove("loading");
    }, [load]);

    return (
        <LayoutGroup type='crossfade' >
            <AnimatePresence mode='wait' >

                {
                    load ?
                        (<motion.div key='loader' >
                            <Loader setLoad={setLoad} />
                        </motion.div>)
                        : <>
                            <Header />
                            <main className='main' data-scroll-container>
                                {children}
                            </main>
                        </>
                }
            </AnimatePresence>
        </LayoutGroup>
    )
}

export default FileStructure